import styled from "styled-components";
import top_bg from "../../../assets/image/top_bg.png";

const Container = styled.div`
  position: relative;
  background: linear-gradient(
    135deg,
    rgba(208, 39, 21, 1) 0%,
    rgba(204, 55, 56, 1) 100%
  );
  overflow: hidden;
  padding: 0.24rem 0.32rem;
  .top-wrap {
    position: relative;
    z-index: 1;
    width: 100%;
    padding: 0.32rem 0.36rem;
    margin: 0 auto;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 249, 236, 1) 100%
    );
    border-radius: 0.12rem;
    box-shadow: inset 0 -1px 0 0 rgba(255, 255, 255, 1);
  }
  .top-bg {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background-image: url("//m.360buyimg.com/img/jfs/t1/7654/27/17727/247075/62ac373dEcaf9dcda/41ef3753551614fc.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .top-bg {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 0;
  }
  .shop-name-wrap {
  }
  .shop-name {
    font-size: 0.36rem;
    font-family: PingFangSC;
    font-weight: bold;
    color: #262626;
    line-height: 1.6;
  }
  .shop-icon {
    display: inline-block;
    vertical-align: text-bottom;
    padding: 0.02rem 0.1rem;
    margin-left: 0.1rem;
    background: #c71622;
    border-radius: 0.05rem;
    font-size: 0.22rem;
    color: #fff;
    white-space: nowrap;
  }
  .license-link {
    display: inline;
    align-items: center;
    height: 0.36rem;
  }
  .license-icon {
    height: 0.4rem;
    object-fit: contain;
    vertical-align: text-bottom;
    margin-left: 0.1rem;
  }
  .nums-wrap {
    display: flex;
    flex-direction: row;
    padding-top: 0.36rem;
  }
  .nums-main {
    display: flex;
    flex-direction: column;
    width: 33.33%;
    max-width: 2rem;
  }
  .nums-value {
    font-size: 0.3rem;
    font-weight: bold;
    color: #262626;
  }
  .nums-txt {
    font-size: 0.24rem;
    color: #999;
    padding-top: 0.16rem;
  }
  .btns-wrap {
    display: flex;
    padding-top: 0.36rem;
  }
  .btn-wrap {
    width: 33.33%;
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    color: #999999;
  }
  .btn-wrap-maxwidth {
    max-width: 2rem;
  }
  .red {
    color: #c71622;
  }
  .btn-icon {
    width: 0.32rem;
    height: 0.32rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .btn-wrap.notice {
    justify-content: flex-end;
  }
  .btn-icon-share {
    background-image: url(//m.360buyimg.com/img/jfs/t1/80052/39/17725/1608/627b5ca0E2d0ba531/ced146690c500bea.png);
    margin-right: 0.12rem;
  }
  .btn-icon-guanzhu {
    background-image: url(//m.360buyimg.com/img/jfs/t1/8925/5/16593/2339/627b5d48E13550713/19356d7fab9e0c9a.png);
    margin-right: 0.12rem;
  }
  .btn-icon-guanzhued {
    background-image: url(//m.360buyimg.com/img/jfs/t1/75874/38/17656/1414/627b5d69Ec3223c63/0c4ae89a90cc4515.png);
    margin-right: 0.12rem;
  }
  .btn-icon-more {
    width: 0.26rem;
    height: 0.26rem;
    background-image: url(//m.360buyimg.com/img/jfs/t1/47087/2/17421/614/627b5d87E48530b29/807da06c0b73b639.png);
    margin-left: 0.05rem;
  }
  .spjs{
    margin-right:.6rem;
  }
  .jgxps{
    // margin-left:.6rem;
    text-align: right;
  }
`;

export { Container };

